import axios from "../../../../axios";
import Cookies from "js-cookie";
import API_BASE_URL from "../../../config/runtimeConfig";


export const GetCandidateDetails = async (submitedCandidateUID) => {
  const token = Cookies.get("employeeToken");

  return axios.post(
    "/api/Candidate/GetCandidateDetails",
    {
      token,
      submitedCandidateUID,
    },
    {
      validateStatus: () => true
    }
  );
};

export const GetCandidateInterviewDetails = async (submitedCandidateUID) => {
  const token = Cookies.get("employeeToken");

  try {
    const interviewDetailsRes = await axios.post(
      "/api/Candidate/GetCandidateInterviewDetails",
      { token, submitedCandidateUID },
      { validateStatus: () => true }
    );

    return {
      interviewDetails: interviewDetailsRes.data,
    };

  } catch (error) {
    return {
      interviewDetails: [],
      error: true,
    };
  }
};

export const GetInterviewFeedbackByUID = async (
  submissionUID,
  interviewUID
) => {
  const token = Cookies.get("employeeToken");

  try {
    const res = await axios.post(
      "/api/Candidate/GetInterviewFeedbackDetails",
      {
        token,
        submissionUID,
        interviewUID,
      },
      { validateStatus: () => true }
    );

    return res.data;

  } catch (error) {
    return null;
  }
};

export const ShortlistCandidate = async (
  SubmitedCandidateUID,
  Status,
  Remark
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/ShortlistCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

export const InterviewSchedule = async (
  SubmitedCandidateUID,
  Status,
  Remark,
  FirstInterviewDateTime,
  InterviewerList
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/ScheduleInterview", {
    token: token,
    status: Status,
    submitedCandidateUID: SubmitedCandidateUID,
    remark: Remark,
    firstInterviewDateTime: FirstInterviewDateTime,
    interviewerList: InterviewerList.map((i) => ({
      interviewerCode: i.interviewerCode,
      interviewSequence: i.interviewSequence,
    })),
  });
};

//Harshada Bhavsar: 26/7/2025
//Selected Candidate and Get Selected Candidate for Employee
export const SelectedCandidate = async (
  SubmitedCandidateUID,
  Status,
  Remark
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/SelectCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

// Harshada Bhavsar: 29/7/2025
// Rejected Candidate

export const RejectedCandidates = async (
  SubmitedCandidateUID,
  Status,
  Remark
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/RejectCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

// Harshada Bhavsar: 07/08/2025
// Hold Candidate

export const HoldCandidates = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/HoldCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

// Harshada Bhavsar: 07/08/2025
// Start Background Verification

export const StartBGV = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/StartBGVCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

// Harshada Bhavsar: 07/08/2025
// Start Background Verification

export const SendAssessmentCandidate = async (
  SubmitedCandidateUID,
  Status,
  Remark,
  AssessmentLink
) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/SendAssessmentCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
    AssessmentLink,
  });
};

// Harshada Bhavsar : 08/08/2025
// Get System Remarks
export const SystemRemark = async (SubmitedCandidateUID) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetSystemRemark", {
    token,
    SubmitedCandidateUID,
  });
};

// Harshdada Bhavsar : 30/7/2025
// View Resume API For Employee
// export const viewResumeUrl = (resumePath) => {
//   const token = Cookies.get("employeeToken");
//   return axios.get(`/api/Metadata/${encodeURIComponent(resumePath)}/${token}`);
// };

// View Resume API For Employee
export const viewResumeUrl = (resumePath) => {
  const token = Cookies.get("employeeToken");
  return `${API_BASE_URL}/api/Metadata/${encodeURIComponent(
    resumePath
  )}/${token}`;
};

// Harshdada Bhavsar : 30/7/2025
// View Resume API For Consultant
export const viewResume = (resumePath) => {
  const token = Cookies.get("ConsultantToken");
  return `${API_BASE_URL}/api/Metadata/${encodeURIComponent(
    resumePath
  )}/${token}`;
};

//Harshada Bhavsar : 11/09/2025
//Schedule Next Interview
export const ScheduleNextInterview = async (interviewUID, interviewDate) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/ScheduleNextInterview", {
    token: token,
    interviewUID: interviewUID,
    interviewDate: interviewDate,
  });
};



// Harshada Bhavsar: 16/12/2025
// Offer Released Candidate

export const OfferReleseCandidate = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/OfferReleseCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

// Harshada Bhavsar: 16/12/2025
// BackOut Candidate

export const BackOutCandidate = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/BackOutCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};


// Harshada Bhavsar: 17/12/2025
// Hire Candidate

export const HireCandidate = async (SubmitedCandidateUID, Status, Remark) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/HireCandidate", {
    token,
    SubmitedCandidateUID,
    Status,
    Remark,
  });
};

export const IsInterviewScheduled = async (submitedCandidateUID) => {
  const token = Cookies.get("employeeToken");

  try {
    const res = await axios.post(
      "/api/Candidate/IsInterviewscheduled",
      { token, submitedCandidateUID }
    );

    return res.data;
  } catch (error) {
    return { status: "Fail", message: "Error checking interview status" };
  }
};
